import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useWallet } from '../../context/WalletContext';
import './BottomNav.css';

const ITEMS = [
  {
    path: '/invest',
    label: 'Purchase',
    icon: (
      <svg viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M6 2l1.5 4h10L19 2M4 6h16l-1.6 12.5a2 2 0 01-2 1.75H7.6a2 2 0 01-2-1.75L4 6zm5 5v5m6-5v5" />
      </svg>
    ),
  },
  {
    path: '/team',
    label: 'Team',
    icon: (
      <svg viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a4 4 0 00-3-3.87M9 20H4v-2a4 4 0 013-3.87m6-4a4 4 0 100-8 4 4 0 000 8zm6 0a3 3 0 100-6 3 3 0 000 6zm-12 0a3 3 0 100-6 3 3 0 000 6z" />
      </svg>
    ),
  },
  {
    path: '/dashboard',
    label: 'Mine',
    special: true,
    icon: (
      <svg viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M14 3l-8 8 4 4 8-8-4-4zm-1 5l3 3M4 20l4-4M12 13l7 7" />
      </svg>
    ),
  },
  {
    path: '/withdraw',
    label: 'Wallet',
    icon: (
      <svg viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-2V6a3 3 0 00-3-3H6a3 3 0 00-3 3v1zm0 0h16M17 13a1 1 0 100 2 1 1 0 000-2z" />
      </svg>
    ),
  },
  {
    path: '/xt-token',
    label: 'XT Token',
    icon: (
      <svg viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="9" strokeLinecap="round" strokeLinejoin="round" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M8 8h8M12 8v9M9 12h6" />
      </svg>
    ),
  },
];

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isConnected } = useWallet();

  // Only show on app pages when connected
  if (!isConnected) return null;
  if (location.pathname === '/') return null;

  return (
    <nav className="bottom-nav">
      {ITEMS.map((item) => {
        const active = location.pathname === item.path;
        return (
          <button
            key={item.path}
            className={`bn-item ${item.special ? 'bn-mine' : ''} ${active ? 'active' : ''}`}
            onClick={() => navigate(item.path)}
          >
            {item.icon}
            {!item.special && <span>{item.label}</span>}
          </button>
        );
      })}
    </nav>
  );
}
